module.exports = __webpack_public_path__ + "img/placemakers-underconstruction-learn.c756ae21.jpg";